import { styled } from "styled-components";

export const PurchasedImage = styled.img`
  width: 150px;
  height: 150px;

  border-radius: 25px;
`;
